<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-school_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">映像視聴ID</p>
    </div>
    <div v-if="isSchool" class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'school-detail' }">戻る</router-link>
    </div>
    <div v-else class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'school' }">戻る</router-link>
    </div>
    <div class="d-flex">
      <div class="subtitle-left">所属教場：{{ currentSchoolDisplay }}</div>
      <div>登録ID数: {{ currentVideoViewingsCountDisplay }}</div>
    </div>
    <div
      class="product-container container"
      v-for="(videoViewingsAndProduct, index) in videoViewingsAndProducts"
      :key="index"
    >
      <p class="font-weight-bold">教材：{{ videoViewingsAndProduct.product.name }}</p>
      <div class="container" v-for="videoViewing in videoViewingsAndProduct.videoViewings" :key="videoViewing.id">
        <div class="tab-content">
          <div id="table-1" class="tab-pane active">
            <div>
              <div>映像視聴ID名: {{ videoViewing.nameReading }}</div>
              <div class="float-right" v-show="allowDeletingVideoViewing">
                <button type="button" class="btn btn-red" @click="prepareDeleteVideoViewing(videoViewing.id)">
                  削除
                </button>
              </div>
            </div>
            <div class="table-wrapper-scroll-y table-content">
              <b-table
                ref="video-viewing-table"
                class="video-viewing-pole-table"
                responsive
                sticky-header
                striped
                :items="videoViewing.videoPoles"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
              >
                <template v-slot:head()="scope">
                  <div class="text-nowrap table-th-stretch">
                    {{ scope.label }}
                  </div>
                </template>
                <template v-slot:cell()="row">
                  <div class="table-td-stretch" :class="{ 'striped-cell': row.index % 2 == 1 }">
                    {{ row.value }}
                  </div>
                </template>
                <template v-slot:cell(uid)="row">
                  <div
                    v-for="(pole, index) in row.item.currentLevelMaterials"
                    :key="pole.level"
                    class="table-td-stretch"
                    :class="{ 'striped-cell': row.index % 2 == 1 }"
                  >
                    <span v-if="index == 0"> {{ row.value }}</span>
                  </div>
                </template>
                <template v-slot:cell(currentLevelMaterials)="row">
                  <div
                    v-for="pole in row.value"
                    :key="pole.level"
                    class="table-td-stretch"
                    :class="{ 'striped-cell': row.index % 2 == 1 }"
                  >
                    {{ pole.name }}
                  </div>
                </template>
                <template v-slot:cell(upgradeLevel)="row">
                  <div
                    v-for="pole in row.item.currentLevelMaterials"
                    :key="pole.level"
                    class="table-td-stretch"
                    :class="{ 'striped-cell': row.index % 2 == 1 }"
                  >
                    <button
                      type="button"
                      class="btn btn-confirm-small"
                      @click="upgradeLevel(videoViewing.id, row.item.id, pole.level)"
                    >
                      進級処理
                    </button>
                  </div>
                </template>

                <template v-slot:cell(changePassword)="row">
                  <div
                    v-for="(pole, index) in row.item.currentLevelMaterials"
                    :key="pole.level"
                    class="table-td-stretch"
                    :class="{ 'striped-cell': row.index % 2 == 1 }"
                  >
                    <button
                      type="button"
                      class="btn btn-confirm-small"
                      @click="changePassword(videoViewing.id, row.item.id)"
                      v-if="index == 0"
                    >
                      パスワード変更
                    </button>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PopUpHolder
      ref="popup_holder"
      show-red-button
      no-close-on-esc
      no-close-on-backdrop
      :red-button-title="popupTypeAdvance ? '進級させる' : '削除する'"
      green-button-title="一覧に戻る"
      @redClick="popupConfirmed"
      @greenClick="popupRejected"
    >
      <template v-slot:header v-if="popupTypeAdvance">進級処理</template>
      <template v-slot:header v-else>削除</template>
      <template v-slot:body v-if="popupTypeAdvance">本当に進級させますか？一度進級させると元には戻せません。</template>
      <template v-slot:body v-else>
        映像視聴ID：{{ currentVideoViewing.nameReading }}を削除しますか？
        <br />一度削除すると元には戻せません。<br />1日～25日の場合、削除したIDは今月分の請求に計上されません。
      </template>
    </PopUpHolder>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { updateTableHeight } from '@/helpers/table';
import { basicSchoolNameIdPresent } from '@/presenters/fields';
import sumBy from 'lodash/sumBy';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    isSchool: {
      type: Boolean,
    },
  },
  components: {
    PopUpHolder,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('school/fetchSchool', routeTo.params.id).then(() => {
        store.dispatch('video_viewing/fetchVideoViewings', routeTo.params.id).then(() => {
          next();
        });
      });
    } else {
      next();
    }
  },
  mounted() {
    updateTableHeight();
  },
  data() {
    const fields = [
      {
        key: 'uid',
        label: '映像視聴ID',
        sortable: false,
        thAttr: { width: 150 },
      },
      {
        key: 'currentLevelMaterials',
        label: '視聴できる教材',
        sortable: false,
        thAttr: { width: 200 },
      },
      {
        key: 'upgradeLevel',
        label: '進級処理',
        sortable: false,
        thAttr: { width: 200 },
      },
      {
        key: 'changePassword',
        label: 'パスワード変更',
        sortable: false,
        thAttr: { width: 200 },
      },
    ];
    return {
      fields: fields,
      currentPage: 1,
      perPage: 4,
      popupTypeAdvance: true,
      currentUpgradingLevel: null,
    };
  },
  computed: {
    currentSchool() {
      return this.school.school;
    },
    currentSchoolDisplay() {
      return basicSchoolNameIdPresent(this.currentSchool);
    },
    currentVideoViewingsCountDisplay() {
      const videos = this.video_viewing.videoViewings;
      const products = this.makeUniqueAndSortProducts(videos);

      let letterContent = '';
      for (const product of products) {
        const videosByProduct = filter(videos, (video) => video.product.id === product.id);
        const totalVideos = videosByProduct.length;
        const totalPoles = sumBy(videosByProduct, (video) => video.videoPoles.length);

        if (product.code === '10' || product.code === '40') {
          letterContent += `【${product.name}】${totalVideos}組（${totalPoles}ID） `;
        } else {
          letterContent += `【${product.name}】${totalPoles}ID `;
        }
      }
      return letterContent;
    },
    currentVideoViewing() {
      return this.video_viewing.videoViewing;
    },
    currentVideoViewingPole() {
      return this.video_viewing_pole.videoViewingPole;
    },
    videoViewingsAndProducts() {
      const videos = this.video_viewing.videoViewings;
      const products = this.makeUniqueAndSortProducts(videos);

      const videosByProduct = [];
      for (const product of products) {
        const filteredVideosByProduct = filter(videos, (video) => video.product.id === product.id);
        videosByProduct.push({
          product,
          videoViewings: filteredVideosByProduct,
        });
      }
      return videosByProduct;
    },
    ...mapState(['school', 'video_viewing', 'video_viewing_pole']),
    ...mapGetters('school', ['getSchoolById']),
    ...mapGetters('video_viewing', ['getVideoViewingById', 'getVideoViewingPoleById']),
    ...mapGetters('role', ['allowDeletingVideoViewing']),
  },
  methods: {
    prepareDeleteVideoViewing(id) {
      this.$logger.debug('Delete video with Id: ' + id);
      this.setVideoViewing(this.getVideoViewingById(id));
      this.popupTypeAdvance = false;
      this.$refs['popup_holder'].show();
    },
    upgradeLevel(videoId, poleId, level) {
      this.$logger.debug(
        'Upgrade Level of video with Id: ' + videoId + ', pole with Id: ' + poleId + ', level: ' + level
      );
      this.setVideoViewing(this.getVideoViewingById(videoId));
      this.setVideoViewingPole(this.getVideoViewingPoleById({ id: videoId, poleId }));
      this.currentUpgradingLevel = level;
      this.popupTypeAdvance = true;
      this.$refs['popup_holder'].show();
    },
    changePassword(videoId, poleId) {
      this.$logger.debug('Change Password for video with Id: ' + videoId + ', pole with Id: ' + poleId);
      this.setVideoViewing(this.getVideoViewingById(videoId));
      this.$router.push({
        name: 'video-viewing-pole-id-change-password',
        params: { id: poleId, schoolId: this.id },
      });
    },
    popupConfirmed() {
      if (this.popupTypeAdvance == true) {
        const payload = { id: this.currentVideoViewingPole.id, type: this.currentUpgradingLevel };
        this.upgradeVideoViewingPoleLevel(payload).then(
          (response) => {
            this.$logger.debug('Popup done for upgrading ' + response);
            this.fetchVideoViewings(this.id);
          },
          (error) => {
            this.$logger.debug('Error ' + error);
          }
        );
      } else {
        this.deleteVideoViewing(this.currentVideoViewing.id).then(
          () => {
            this.$logger.debug('Popup done for deleting');
            this.fetchVideoViewings(this.id);
          },
          (error) => {
            this.$logger.debug('Error ' + error);
          }
        );
      }
    },
    popupRejected() {
      this.$logger.debug('Popup cancelled');
    },
    makeUniqueAndSortProducts(videos) {
      const filteredProducts = [];
      for (const video of videos) {
        const hasFilteredProduct = filteredProducts.some((filteredProduct) => {
          return filteredProduct.id === video.product.id;
        });
        if (!hasFilteredProduct) filteredProducts.push(video.product);
      }
      return sortBy(filteredProducts, 'position');
    },
    ...mapActions('video_viewing', ['deleteVideoViewing', 'fetchVideoViewings', 'setVideoViewing']),
    ...mapActions('video_viewing_pole', ['setVideoViewingPole', 'upgradeVideoViewingPoleLevel']),
  },
};
</script>

<style scoped>
.subtitle-left {
  margin-right: 30px;
}
.btn-confirm-small {
  font-size: 10px;
  margin-bottom: 2px;
  padding: 10px 32px;
}
.product-container {
  background-color: #eeeeee;
}
.container {
  padding: 20px;
}
.table-th-stretch {
  padding: 5px 5px 5px 20px;
}
.table-td-stretch {
  height: 50px;
  padding: 5px 5px 5px 20px;
  display: flex;
  align-items: center;
}
.float-right {
  margin-top: -20px;
}
.table-content {
  margin-top: 40px;
}
.striped-cell {
  background: white;
}
</style>
